<template>
    <div class="sustainable-component competence-individual">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-individual</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-6">
                    <v-select bg-color="white" variant="outlined" label="Anställd" :items="employees" v-model="selectedEmployeeId" item-title="CompleteName" item-value="EmployeeId"></v-select>
                    <v-btn v-bind:disabled="disabled" v-if="selectedEmployeeId != null" size="default" color="primary" class="mb-3 btn-primary" @click="save">
                        spara
                    </v-btn>
                </div>
                <div class="col-6">
                    <a href="javascript:void(0)" @click="printEmployeeCompetences">Skriv ut individuella kompetenser</a><br />
                    <a href="javascript:void(0)" @click="printAllCompetence">Skriv ut alla kompetenser</a>
                </div>
            </div>
            <div class="row" v-if="selectedEmployeeId != null">
                <div class="col-6 col-md-3" v-for="(item, index) in competenceList" :key="index">
                    <CompetenceEmplyeeCategoryCompetence v-bind:disabled="disabled" @updated="reload" :categoryname="item.Name" :competencecategoryid="item.CompetenceCategoryId" :competencelist="item.CompetenceList"></CompetenceEmplyeeCategoryCompetence>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import CompetenceEmplyeeCategoryCompetence from './competence-emplyee-category-competence.vue'
    import WageService from "../../Services/WageService";
    import CompetenceService from "../../Services/CompetenceService";
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {

        name: 'competence-individual',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CompetenceEmplyeeCategoryCompetence,
            CommonSpinner
        },
        methods: {
            async loadComptence() {
                this.loading++;
                try {
                    var competenceList = await CompetenceService.getEmployeeCompetence(this.selectedEmployeeId);
                    this.competenceList = competenceList;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadEmployees() {
                this.loading++;
                try {
                    var employees = [{ CompleteName: 'Ingen vald', EmployeeId: null }, ... await WageService.getEmployeesFromCompany("Fornamn")];
                    this.employees = employees;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async save() {
                this.loading++;
                try {
                    await CompetenceService.saveEmployeeCompetence(this.selectedEmployeeId, this.competenceList);
                    this.displaySnackBar("Sparat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            printEmployeeCompetences() {
                if (this.selectedEmployeeId == null) {
                    alert("Välj anställd")
                    return;
                }
                this.newWindow = window.open('/competenceprint/PrintEmployeeEducation?employeeId=' + this.selectedEmployeeId, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            printAllCompetence() {
                this.newWindow = window.open('/competenceprint/PrintAllEmployeeEducation', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },

        },

        data() {
            return {
                competenceList:[],
                employees:[],
                selectedEmployeeId: null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedEmployeeId: function () {
                this.loadComptence();
            }

        },
        mounted() {
            this.internalModel = this.model;
            this.loadEmployees();
        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

   
</style>
